export enum ReleaseNoteDisplayFrequency {
  ALWAYS = 'ALWAYS',
  EVERY_LOGIN = 'EVERY_LOGIN',
  FIRST_LOGIN = 'FIRST_LOGIN',
  NEVER = 'NEVER'
}
